import { createFileRoute } from '@tanstack/react-router';
import { HelpArticlePage } from '@/pages/help';
import type { HelpCategorySlug } from '@repo/utils';

export const Route = createFileRoute(
  '/protected/_layout/help/$category/$article'
)({
  component: HelpArticleRoute,
});

function HelpArticleRoute() {
  const { category, article } = Route.useParams();

  return (
    <HelpArticlePage
      category={category as HelpCategorySlug}
      articleSlug={article}
    />
  );
}
